import { DateTime } from 'luxon';
import { BenefitDTO, FitnessBenefitDetailsDTO, FitnessBenefitDetailsDTOStatusEnum } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';
import { getFitnessStatus } from '../../nonCashBenefits/hooks/useNonCashBenefitState';

export class FitnessBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsFitness = activeBenefit.details as FitnessBenefitDetailsDTO;
    const isActive =
      detailsFitness.status === FitnessBenefitDetailsDTOStatusEnum.Active ||
      detailsFitness.status === FitnessBenefitDetailsDTOStatusEnum.Expiring;
    const fitnessStatus = getFitnessStatus(detailsFitness.status);

    return {
      icon: getBenefitIcon(detailsFitness.benefit),
      titleKey: `benefit.${detailsFitness.benefit}.name`,
      navigateTo: `/fitness`,
      picture: BENEFIT_PICTURES[detailsFitness.benefit],
      descriptionKey: `benefitModule:benefit.${detailsFitness.benefit}.headerStatus.${fitnessStatus}`,
      descriptionValues: {
        startDate: new Date(detailsFitness.startDate),
        endDate: detailsFitness.endDate ? DateTime.fromISO(detailsFitness.endDate).plus({ months: 1 }).toJSDate() : undefined,
      },
      benefitProgress: isActive ? 100 : 0,
    };
  }
}
